import { useState } from 'react'
import { useSearchParams, useNavigate, Link } from 'react-router-dom'
import { apiPost, ApiError } from '@/lib/api'
import { queryClient } from '@/lib/queryClient'

export function MagicLinkLanding() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = searchParams.get('token')
  const email = searchParams.get('email')

  const [verifying, setVerifying] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleVerify() {
    setError(null)
    setVerifying(true)
    try {
      await apiPost('/auth/magic-link/verify', { token, email })
      await queryClient.invalidateQueries({ queryKey: ['auth', 'me'] })
      navigate('/dashboard', { replace: true })
    } catch (err) {
      if (err instanceof ApiError) {
        if (err.message.toLowerCase().includes('expired')) {
          setError('El enlace ha expirado. Solicita uno nuevo.')
        } else if (err.message.toLowerCase().includes('already used')) {
          setError('Este enlace ya fue utilizado.')
        } else {
          setError(
            err.message ||
              'Error al verificar. Intenta solicitar un nuevo enlace.',
          )
        }
      } else {
        setError('Error al verificar. Intenta solicitar un nuevo enlace.')
      }
    } finally {
      setVerifying(false)
    }
  }

  // Invalid link — missing required params
  if (!token || !email) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="w-full max-w-md rounded-lg bg-white p-8 text-center shadow-md">
          <h1 className="text-2xl font-bold text-gray-900">1-Klick Sales</h1>
          <p className="mt-4 text-red-600">Enlace invalido</p>
          <p className="mt-2 text-sm text-gray-500">
            El enlace no contiene los parametros necesarios.
          </p>
          <Link
            to="/login"
            className="mt-4 inline-block text-sm font-medium text-primary hover:underline"
          >
            Volver a iniciar sesion
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-md">
        {/* Header */}
        <h1 className="text-center text-2xl font-bold text-gray-900">
          1-Klick Sales
        </h1>
        <p className="mt-4 text-center text-sm text-gray-600">
          Haz clic en el boton para iniciar sesion
        </p>
        <p className="mt-2 text-center text-sm text-gray-500">{email}</p>

        {/* Verify button — POST trigger (two-step pattern) */}
        <button
          type="button"
          onClick={handleVerify}
          disabled={verifying}
          className="mt-6 w-full rounded-md bg-primary px-4 py-2.5 text-sm font-medium text-white hover:bg-primary/90 disabled:opacity-50"
        >
          {verifying ? 'Verificando...' : 'Iniciar sesion'}
        </button>

        {error && (
          <div className="mt-4 rounded-md bg-red-50 p-3 text-center">
            <p className="text-sm text-red-600">{error}</p>
            <Link
              to="/login"
              className="mt-2 inline-block text-sm font-medium text-primary hover:underline"
            >
              Solicitar nuevo enlace
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}
